import FormattedDatePicker from "@/components/FormattedDatePicker/FormattedDatePicker";
import {
  APPLY_BUTTON_VARIANT,
  CANCEL_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import {
  MotifButton,
  MotifFormField,
  MotifLabel,
  MotifInput,
  MotifSelect,
  MotifOption,
  MotifIcon,
} from "@ey-xd/motif-react";
import { IconoirXmark } from "@ey-xd/motif-icon";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetTaskTypeList } from "@/utility/common";

interface Status {
  id: string;
  name: string;
}
interface Type {
  value: string;
  label: string;
}

const BasicSearch = ({
  setShowBasicSearch,
  handleSubmit,
  formValues,
  setFormValues,
}: any) => {
  const { t } = useTranslation();
  const defaultStatusOptions: Status[] = [
    { id: "0", name: "Open" },
    { id: "1", name: "Closed" },
    { id: "2", name: "Complete" },
  ];
  const [statusOptions] = useState<Status[]>(defaultStatusOptions);
  const defaultTypeOptions: Type[] = useGetTaskTypeList();

  const [typeOptions] = useState<Type[]>(defaultTypeOptions);
  const handleChange = (name: any, value: any) => {
    setFormValues((prev: any) => ({ ...prev, [name]: value }));
  };
  return (
    <div className="claims-basic-search-container">
      <div className="motif-row">
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.tasks.search.claimId")}</MotifLabel>
          <MotifFormField>
            <MotifInput
              /*@ts-ignore */
              onChange={(e: any) => {
                handleChange("ClaimReference", e.target.value);
              }}
              value={formValues.ClaimReference}
              hideClearButton={true}
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.tasks.search.name")}</MotifLabel>
          <MotifFormField>
            <MotifInput
              /*@ts-ignore */
              onChange={(e: any) => {
                handleChange("Name", e.target.value);
              }}
              value={formValues.Name}
              hideClearButton={true}
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.tasks.search.overdue")}</MotifLabel>
          <MotifFormField>
            <MotifSelect
              onChange={(value) => {
                handleChange("Overdue", value);
              }}
              value={formValues.Overdue}
            >
              <MotifOption value={true}>Yes</MotifOption>
              <MotifOption value={false}>No</MotifOption>
            </MotifSelect>
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.tasks.search.taskType")}</MotifLabel>
          <MotifFormField>
            <MotifSelect
              onChange={(value) => {
                handleChange("Type", value);
              }}
              value={formValues.Type}
            >
              {typeOptions.map((option: any) => (
                <MotifOption value={option.value}>{option.label}</MotifOption>
              ))}
            </MotifSelect>
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.tasks.search.status")}</MotifLabel>
          <MotifFormField>
            <MotifSelect
              onChange={(value) => {
                handleChange("Status", value);
              }}
              value={formValues.Status || []}
              multiple={true}
            >
              {statusOptions.map((option: { id: string; name: string }) => (
                <MotifOption key={option.id} value={option.id}>
                  {option.name}
                </MotifOption>
              ))}
            </MotifSelect>
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.tasks.search.dueDateStart")}</MotifLabel>
          <MotifFormField>
            <FormattedDatePicker
              todayMark={true}
              range={false}
              onChange={(value) => {
                if (value) {
                  handleChange("DueDateStart", value);
                }
              }}
              value={formValues.DueDateStart || undefined}
              maxDate={
                formValues.DueDateEnd
                  ? new Date(formValues.DueDateEnd)
                  : undefined
              }
              clearIcon={
                <MotifIcon
                  //@ts-ignore
                  onClick={() =>
                    setFormValues({
                      ...formValues,
                      DueDateStart: "",
                    })
                  }
                  src={IconoirXmark}
                />
              }
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.tasks.search.dueDateEnd")}</MotifLabel>
          <MotifFormField>
            <FormattedDatePicker
              todayMark={true}
              range={false}
              onChange={(value) => {
                if (value) {
                  handleChange("DueDateEnd", value);
                }
              }}
              value={formValues.DueDateEnd || undefined}
              minDate={
                formValues.DueDateStart
                  ? new Date(formValues.DueDateStart)
                  : undefined
              }
              clearIcon={
                <MotifIcon
                  //@ts-ignore
                  onClick={() =>
                    setFormValues({
                      ...formValues,
                      DueDateEnd: "",
                    })
                  }
                  src={IconoirXmark}
                />
              }
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.tasks.search.createdOnStart")}</MotifLabel>
          <MotifFormField>
            <FormattedDatePicker
              todayMark={true}
              range={false}
              onChange={(value) => {
                if (value) {
                  handleChange("CreatedOnStart", value);
                }
              }}
              maxDate={
                formValues.CreatedOnEnd
                  ? new Date(formValues.CreatedOnEnd)
                  : undefined
              }
              value={formValues.CreatedOnStart || undefined}
              clearIcon={
                <MotifIcon
                  //@ts-ignore
                  onClick={() =>
                    setFormValues({
                      ...formValues,
                      CreatedOnStart: "",
                    })
                  }
                  src={IconoirXmark}
                />
              }
            />
          </MotifFormField>
        </div>
        <div className="motif-col-xs-1  motif-col-md-2 motif-col-lg-4">
          <MotifLabel>{t("pages.tasks.search.createdOnEnd")}</MotifLabel>
          <MotifFormField>
            <FormattedDatePicker
              todayMark={true}
              range={false}
              onChange={(value) => {
                if (value) {
                  handleChange("CreatedOnEnd", value);
                }
              }}
              value={formValues.CreatedOnEnd || undefined}
              minDate={
                formValues.CreatedOnStart
                  ? new Date(formValues.CreatedOnStart)
                  : undefined
              }
              clearIcon={
                <MotifIcon
                  //@ts-ignore
                  onClick={() =>
                    setFormValues({
                      ...formValues,
                      CreatedOnEnd: "",
                    })
                  }
                  src={IconoirXmark}
                />
              }
            />
          </MotifFormField>
        </div>
        <div className="basic-search-buttons">
          <MotifButton
            size="small"
            type="button"
            variant={CANCEL_BUTTON_VARIANT}
            onClick={() => {
              setShowBasicSearch(false);
            }}
          >
            {t("global.globalActions.cancel")}
          </MotifButton>

          <MotifButton
            size="small"
            variant={APPLY_BUTTON_VARIANT}
            onClick={() => {
              setShowBasicSearch(false);
              handleSubmit();
            }}
          >
            {t("global.globalActions.apply")}
          </MotifButton>
        </div>
      </div>
    </div>
  );
};
export default BasicSearch;
